import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEFAULT_FRONTEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const AppSettingsContext = createContext(null);

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error("useAppSettings must be used within AppSettingsProvider");
  }
  return context;
};

export const AppSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    frontend_url: DEFAULT_FRONTEND_URL,
    stripe_enabled: true,
    mbway_enabled: true,
    whatsapp_number: "",
    subscription_default_price: 30,
    subscription_default_weekly_credits: 2,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/settings/public`);
        setSettings(prev => ({
          ...prev,
          ...res.data,
          // Use configured URL or fallback to default
          frontend_url: res.data.frontend_url || DEFAULT_FRONTEND_URL,
        }));
      } catch (err) {
        console.warn("Failed to load app settings, using defaults");
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  // Helper to get the correct app URL (for QR codes, emails, etc.)
  const getAppUrl = (path = "") => {
    const baseUrl = settings.frontend_url.replace(/\/$/, "");
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${baseUrl}${cleanPath}`;
  };

  return (
    <AppSettingsContext.Provider value={{ settings, loading, getAppUrl }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export default AppSettingsContext;
